import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";

import { OpcionesEstadosTratamientos } from "../components/OpcionesEstadosTratamientos";

import * as APIPSICOTERAPIA from "../services/psicoterapia";

import {
  PsicoterapiaUpdate,
  TratamientoEstadoUpdate,
} from "./PsicoterapiaUpdate";
import { PsicoterapiaDelete } from "./PsicoterapiaDelete";

export function PsicoterapiaEdit(props) {
  const psicoterapia = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = psicoterapia.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [psicResp, setPsicResp] = useState(psicoterapia.meta?.psicResp);
  const [psicFecha, setPsicFecha] = useState(psicoterapia.meta?.metaFecha);
  const [psicNumses, setPsicNumses] = useState(psicoterapia.meta?.psicNumses);
  const [psicMedio, setPsicMedio] = useState(psicoterapia.meta?.psicMedio);
  const [psicNeuronRad, setPsicNeuronRad] = useState(
    psicoterapia.meta?.psicNeuronRad
  );
  const [psicNeuronEsp, setPsicNeuronEsp] = useState(
    psicoterapia.meta?.psicNeuronEsp
  );
  const [psicMedafRad, setPsicMedafRad] = useState(
    psicoterapia.meta?.psicMedafRad
  );
  const [psicMedafEsp, setPsicMedafEsp] = useState(
    psicoterapia.meta?.psicMedafEsp
  );
  const [psicNaltRad, setPsicNaltRad] = useState(
    psicoterapia.meta?.psicNaltRad
  );
  const [psicNaltEsp, setPsicNaltEsp] = useState(
    psicoterapia.meta?.psicNaltEsp
  );
  const [psicAntRad, setPsicAntRad] = useState(psicoterapia.meta?.psicAntRad);
  const [psicAntEsp, setPsicAntEsp] = useState(psicoterapia.meta?.psicAntEsp);
  const [psicOtramedRad, setPsicOtramedRad] = useState(
    psicoterapia.meta?.psicOtramedRad
  );
  const [psicOtramedEsp, setPsicOtramedEsp] = useState(
    psicoterapia.meta?.psicOtramedEsp
  );
  const [psicSueno, setPsicSueno] = useState(psicoterapia.meta?.psicSueno);
  const [psicFrecuenciaSueno, setPsicFrecuenciaSueno] = useState(
    psicoterapia.meta?.psicFrecuenciaSueno
  );
  const [psicCalidadSueno, setPsicCalidadSueno] = useState(
    psicoterapia.meta?.psicCalidadSueno
  );
  const [psicConsdrogprinc, setPsicConsdrogprinc] = useState(
    psicoterapia.meta?.psicConsdrogprinc
  );
  const [psicConsdrogotras, setPsicConsdrogotras] = useState(
    psicoterapia.meta?.psicConsdrogotras
  );
  const [psicActivRad, setPsicActivRad] = useState(
    psicoterapia.meta?.psicActivRad
  );
  const [psicRelsocRad, setPsicRelsocRad] = useState(
    psicoterapia.meta?.psicRelsocRad
  );
  const [psicTestorinRad, setPsicTestorinRad] = useState(
    psicoterapia.meta?.psicTestorinRad
  );
  const [psicObs, setPsicObs] = useState(psicoterapia.meta?.psicObs);
  const [psicTipoDroga, setPsicTipoDroga] = useState(
    psicoterapia.meta?.psicTipoDroga
  );
  const [psicResult, setPsicResult] = useState(psicoterapia.meta?.psicResult);

  const [psicEstado, setPsicEstado] = useState(
    psicoterapia.meta?.psicEstado || "seguimiento"
  );

  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let psicoterapiaId = psicoterapia.id;
  const psicDate = new Date(psicoterapia.date);
  const diffDate = Math.abs(new Date() - psicDate) / 36e5;

  const submitPsicoterapia = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      psicResp,
      psicFecha,
      psicNumses,
      psicMedio,
      psicNeuronRad,
      psicNeuronEsp,
      psicMedafRad,
      psicMedafEsp,
      psicNaltRad,
      psicNaltEsp,
      psicAntRad,
      psicAntEsp,
      psicOtramedRad,
      psicOtramedEsp,
      psicSueno,
      psicFrecuenciaSueno,
      psicCalidadSueno,
      psicConsdrogprinc,
      psicConsdrogotras,
      psicActivRad,
      psicRelsocRad,
      psicTestorinRad,
      psicTipoDroga,
      psicResult,
      psicObs,
      psicEstado,
      tratamientoId,
      pacienteId,
      psicoterapiaId
    );
    try {
      await PsicoterapiaUpdate(
        psicResp,
        psicFecha,
        psicNumses,
        psicMedio,
        psicNeuronRad,
        psicNeuronEsp,
        psicMedafRad,
        psicMedafEsp,
        psicNaltRad,
        psicNaltEsp,
        psicAntRad,
        psicAntEsp,
        psicOtramedRad,
        psicOtramedEsp,
        psicSueno,
        psicFrecuenciaSueno,
        psicCalidadSueno,
        psicConsdrogprinc,
        psicConsdrogotras,
        psicActivRad,
        psicRelsocRad,
        psicTestorinRad,
        psicTipoDroga,
        psicResult,
        psicObs,
        psicEstado,
        tratamientoId,
        pacienteId,
        psicoterapiaId
      ).then(
        async (val) => {
          const response = await APIPSICOTERAPIA.getAllPsicoterapiaByTax(
            tratamientoId
          );
          const currentMaxNumses = Math.max(
            ...response.map((item) => item.meta.psicNumses)
          );

          if (psicNumses >= currentMaxNumses) {
            // Realiza la llamada adicional a la API aquí
            await TratamientoEstadoUpdate(psicEstado, tratamientoId);
          }

          navigate(
            `../${tratamientoId}/seguimiento/psicoterapia/${psicoterapiaId}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await PsicoterapiaDelete(psicoterapiaId).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        {psicoterapia.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id="formUpdatelement" onSubmit={submitPsicoterapia}>
            <fieldset id="disabledContainer">
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="psicResp">Responsable</label>
                  <div className="control">
                    <input
                      className="input"
                      id="psicResp"
                      required
                      type="text"
                      value={psicResp}
                      onChange={(e) => setPsicResp(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="psicFecha">Fecha visita</label>
                  <div className="control">
                    <input
                      className="input"
                      id="psicFecha"
                      required
                      type="date"
                      value={psicFecha}
                      onChange={(e) => setPsicFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="psicNumses">Número de sesión</label>
                  <div className="control">
                    {props.userRole.includes("administrador") ? (
                      <input
                        className="input"
                        id="psicNumses"
                        required
                        type="number"
                        value={psicNumses}
                        onChange={(e) => setPsicNumses(e.target.value)}
                      />
                    ) : (
                      <input
                        className="input"
                        id="psicNumses"
                        required
                        disabled
                        type="number"
                        value={psicNumses}
                        onChange={(e) => setPsicNumses(e.target.value)}
                      />
                    )}
                  </div>
                </div>

                <div className="field">
                  <label htmlFor="psicMedio">Asistencia / Medio</label>
                  <div className="control">
                    <div className="select">
                      <select
                        className="select"
                        id="psicMedio"
                        required
                        name="psicMedio"
                        value={psicMedio}
                        onChange={(e) => setPsicMedio(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="presencial">Presencial</option>
                        <option value="videoconferencia">
                          Videoconferencia
                        </option>
                        <option value="no-asistencia">No Asistencia</option>
                      </select>
                    </div>
                  </div>
                </div>

                {props.userRole.includes("administrador") && (
                  <div className="field">
                    <label htmlFor="psicEstado">Estado de seguimiento</label>
                    <div className="control">
                      <div className="select">
                        <select
                          className="select"
                          id="psicEstado"
                          name="psicEstado"
                          value={psicEstado}
                          onChange={(e) => setPsicEstado(e.target.value)}
                        >
                          {OpcionesEstadosTratamientos.map((option) => (
                            <option
                              key={option.value}
                              value={option.value}
                              disabled={option.disabled}
                            >
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="grid--2col">
                <div className="field key" data-key={psicNeuronRad?.toString()}>
                  <div className="control">
                    <label className="radio-title">Neurontin</label>
                    <label className="radio" htmlFor="psicNeuronRadSi">
                      <input
                        id="psicNeuronRadSi"
                        name="psicNeuronRad"
                        type="radio"
                        value="Si"
                        checked={psicNeuronRad === "Si"}
                        onChange={(e) => setPsicNeuronRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="psicNeuronRadNo">
                      <input
                        id="psicNeuronRadNo"
                        name="psicNeuronRad"
                        type="radio"
                        value="No"
                        checked={psicNeuronRad === "No"}
                        onChange={(e) => setPsicNeuronRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className="field lock">
                  <label htmlFor="psicNeuronEsp">
                    Neurontin-Especificar mg/día
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="psicNeuronEsp"
                      type="text"
                      value={psicNeuronEsp}
                      onChange={(e) => setPsicNeuronEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field key" data-key={psicMedafRad?.toString()}>
                  <div className="control">
                    <label className="radio-title">Modafinilo</label>
                    <label className="radio" htmlFor="psicMedafRadSi">
                      <input
                        id="psicMedafRadSi"
                        name="psicMedafRad"
                        type="radio"
                        value="Si"
                        checked={psicMedafRad === "Si"}
                        onChange={(e) => setPsicMedafRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="psicMedafRadNo">
                      <input
                        id="psicMedafRadNo"
                        name="psicMedafRad"
                        type="radio"
                        value="No"
                        checked={psicMedafRad === "No"}
                        onChange={(e) => setPsicMedafRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className="field lock">
                  <label htmlFor="psicMedafEsp">
                    Modafinilo-Especificar mg/día
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="psicMedafEsp"
                      type="text"
                      value={psicMedafEsp}
                      onChange={(e) => setPsicMedafEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field key" data-key={psicNaltRad?.toString()}>
                  <div className="control">
                    <label className="radio-title">Naltrexona</label>
                    <label className="radio" htmlFor="psicNaltRadSi">
                      <input
                        id="psicNaltRadSi"
                        name="psicNaltRad"
                        type="radio"
                        value="Si"
                        checked={psicNaltRad === "Si"}
                        onChange={(e) => setPsicNaltRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="psicNaltRadNo">
                      <input
                        id="psicNaltRadNo"
                        name="psicNaltRad"
                        type="radio"
                        value="No"
                        checked={psicNaltRad === "No"}
                        onChange={(e) => setPsicNaltRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className="field lock">
                  <label htmlFor="psicNaltEsp">
                    Naltrexona-Especificar mg/día
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="psicNaltEsp"
                      type="text"
                      value={psicNaltEsp}
                      onChange={(e) => setPsicNaltEsp(e.target.value)}
                    />
                  </div>
                </div>

                <div className="field key" data-key={psicAntRad?.toString()}>
                  <div className="control">
                    <label className="radio-title">Antabus</label>
                    <label className="radio" htmlFor="psicAntRadSi">
                      <input
                        id="psicAntRadSi"
                        name="psicAntRad"
                        type="radio"
                        value="Si"
                        checked={psicAntRad === "Si"}
                        onChange={(e) => setPsicAntRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="psicAntRadNo">
                      <input
                        id="psicAntRadNo"
                        name="psicAntRad"
                        type="radio"
                        value="No"
                        checked={psicAntRad === "No"}
                        onChange={(e) => setPsicAntRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className="field lock">
                  <label htmlFor="psicAntEsp">Antabus-Especificar mg/día</label>
                  <div className="control">
                    <input
                      className="input"
                      id="psicAntEsp"
                      type="text"
                      value={psicAntEsp}
                      onChange={(e) => setPsicAntEsp(e.target.value)}
                    />
                  </div>
                </div>

                <div
                  className="field key"
                  data-key={psicOtramedRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">Otra medicación</label>
                    <label className="radio" htmlFor="psicOtramedRadSi">
                      <input
                        id="psicOtramedRadSi"
                        name="psicOtramedRad"
                        type="radio"
                        value="Si"
                        checked={psicOtramedRad === "Si"}
                        onChange={(e) => setPsicOtramedRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="psicOtramedRadNo">
                      <input
                        id="psicOtramedRadNo"
                        name="psicOtramedRad"
                        type="radio"
                        value="No"
                        checked={psicOtramedRad === "No"}
                        onChange={(e) => setPsicOtramedRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className="field lock">
                  <label htmlFor="psicOtramedEsp">
                    Otra medicación - Especificar
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="psicOtramedEsp"
                      type="text"
                      value={psicOtramedEsp}
                      onChange={(e) => setPsicOtramedEsp(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="field key" data-key={psicSueno.toString()}>
                <div className="control">
                  <label className="radio-title">Sueño</label>
                  <label className="radio" htmlFor="psicSueno01">
                    <input
                      id="psicSueno01"
                      name="psicSueno"
                      type="radio"
                      value="Bueno"
                      checked={psicSueno === "Bueno"}
                      onChange={(e) => setPsicSueno(e.target.value)}
                      disabled
                    />
                    Bueno
                  </label>
                  <label className="radio" htmlFor="psicSueno02">
                    <input
                      id="psicSueno02"
                      name="psicSueno"
                      type="radio"
                      value="Regular"
                      checked={psicSueno === "Regular"}
                      onChange={(e) => setPsicSueno(e.target.value)}
                      disabled
                    />
                    Regular
                  </label>
                  <label className="radio" htmlFor="psicSueno03">
                    <input
                      id="psicSueno03"
                      name="psicSueno"
                      type="radio"
                      value="Malo"
                      checked={psicSueno === "Malo"}
                      onChange={(e) => setPsicSueno(e.target.value)}
                      disabled
                    />
                    Malo
                  </label>
                </div>
              </div>


            <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='psicFrecuenciaSueno'>
                  Frecuencia de dificultades para conciliar o mantener el sueño
                </label>
                <div className='control'>
                  <div className='select'>
                    <select
                      className='select'
                      id='psicFrecuenciaSueno'
                      name='psicFrecuenciaSueno'
                      required
                      value={psicFrecuenciaSueno}
                      onChange={(e) => setPsicFrecuenciaSueno(e.target.value)}
                    >
                      <option disabled value=''>
                        -- Selecciona una opción --
                      </option>
                      <option value='casi-nunca'>
                        Casi nunca (menos de 1 noche por semana)
                      </option>
                      <option value='algunas-veces'>
                        Algunas veces (1-2 noches por semana)
                      </option>
                      <option value='a-menudo'>
                        A menudo (3-4 noches por semana)
                      </option>
                      <option value='casi-siempre'>
                        Casi siempre (5-7 noches por semana)
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div className='field'>
                <label htmlFor='psicCalidadSueno'>
                  Calidad general del sueño
                </label>
                <div className='control'>
                  <div className='select'>
                    <select
                      className='select'
                      id='psicCalidadSueno'
                      name='psicCalidadSueno'
                      required
                      value={psicCalidadSueno}
                      onChange={(e) => setPsicCalidadSueno(e.target.value)}
                    >
                      <option disabled value=''>
                        -- Selecciona una opción --
                      </option>
                      <option value='muy-buena'>
                        Muy buena (se siente descansado y con energía al despertar)
                      </option>
                      <option value='buena'>
                        Buena (generalmente se siente descansado)
                      </option>
                      <option value='regular'>
                        Regular (a veces se siente cansado durante el día)
                      </option>
                      <option value='mala'>
                        Mala (raramente se siente descansado)
                      </option>
                      <option value='muy-mala'>
                        Muy mala (se siente constantemente cansado y con falta de energía)
                      </option>
                    </select>
                  </div>
                </div>
              </div>

          </div>

              <div
                className="field key"
                data-key={psicConsdrogprinc.toString()}
              >
                <div className="control">
                  <label className="radio-title">Consumo droga principal</label>
                  <label className="radio" htmlFor="psicConsdrogprinc01">
                    <input
                      id="psicConsdrogprinc01"
                      name="psicConsdrogprinc"
                      type="radio"
                      value="No ha consumido"
                      checked={psicConsdrogprinc === "No ha consumido"}
                      onChange={(e) => setPsicConsdrogprinc(e.target.value)}
                    />
                    No ha consumido
                  </label>
                  <label className="radio" htmlFor="psicConsdrogprinc02">
                    <input
                      id="psicConsdrogprinc02"
                      name="psicConsdrogprinc"
                      type="radio"
                      value="Se sospecha consumo"
                      checked={psicConsdrogprinc === "Se sospecha consumo"}
                      onChange={(e) => setPsicConsdrogprinc(e.target.value)}
                    />
                    Se sospecha consumo
                  </label>
                  <label className="radio" htmlFor="psicConsdrogprinc03">
                    <input
                      id="psicConsdrogprinc03"
                      name="psicConsdrogprinc"
                      type="radio"
                      value="Si ha consumido"
                      checked={psicConsdrogprinc === "Si ha consumido"}
                      onChange={(e) => setPsicConsdrogprinc(e.target.value)}
                    />
                    Sí ha consumido
                  </label>
                </div>
              </div>

              <div
                className="field key"
                data-key={psicConsdrogotras.toString()}
              >
                <div className="control">
                  <label className="radio-title">Consumo otras drogas</label>
                  <label className="radio" htmlFor="psicConsdrogotras01">
                    <input
                      id="psicConsdrogotras01"
                      name="psicConsdrogotras"
                      type="radio"
                      value="No ha consumido"
                      checked={psicConsdrogotras === "No ha consumido"}
                      onChange={(e) => setPsicConsdrogotras(e.target.value)}
                    />
                    No ha consumido
                  </label>
                  <label className="radio" htmlFor="psicConsdrogotras02">
                    <input
                      id="psicConsdrogotras02"
                      name="psicConsdrogotras"
                      type="radio"
                      value="Se sospecha consumo"
                      checked={psicConsdrogotras === "Se sospecha consumo"}
                      onChange={(e) => setPsicConsdrogotras(e.target.value)}
                    />
                    Se sospecha consumo
                  </label>
                  <label className="radio" htmlFor="psicConsdrogotras03">
                    <input
                      id="psicConsdrogotras03"
                      name="psicConsdrogotras"
                      type="radio"
                      value="Si ha consumido"
                      checked={psicConsdrogotras === "Si ha consumido"}
                      onChange={(e) => setPsicConsdrogotras(e.target.value)}
                    />
                    Sí ha consumido
                  </label>
                </div>
              </div>

              <div className="grid--2col">
                <div className="field key" data-key={psicActivRad?.toString()}>
                  <div className="control">
                    <label className="radio-title">Actividades</label>
                    <label className="radio" htmlFor="psicActivRadSi">
                      <input
                        id="psicActivRadSi"
                        name="psicActivRad"
                        type="radio"
                        value="Si"
                        checked={psicActivRad === "Si"}
                        onChange={(e) => setPsicActivRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="psicActivRadNo">
                      <input
                        id="psicActivRadNo"
                        name="psicActivRad"
                        type="radio"
                        value="No"
                        checked={psicActivRad === "No"}
                        onChange={(e) => setPsicActivRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className="field key" data-key={psicRelsocRad?.toString()}>
                  <div className="control">
                    <label className="radio-title">Relaciones sociales</label>
                    <label className="radio" htmlFor="psicRelsocRadSi">
                      <input
                        id="psicRelsocRadSi"
                        name="psicRelsocRad"
                        type="radio"
                        value="Si"
                        checked={psicRelsocRad === "Si"}
                        onChange={(e) => setPsicRelsocRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="psicRelsocRadNo">
                      <input
                        id="psicRelsocRadNo"
                        name="psicRelsocRad"
                        type="radio"
                        value="No"
                        checked={psicRelsocRad === "No"}
                        onChange={(e) => setPsicRelsocRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                {/* <div
                  className='field key'
                  data-key={psicTestorinRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>Test de orina</label>
                    <label className='radio' htmlFor='psicTestorinRadSi'>
                      <input
                        id='psicTestorinRadSi'
                        name='psicTestorinRad'
                        type='radio'
                        value='Si'
                        checked={psicTestorinRad === "Si"}
                        onChange={(e) => setPsicTestorinRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='psicTestorinRadNo'>
                      <input
                        id='psicTestorinRadNo'
                        name='psicTestorinRad'
                        type='radio'
                        value='No'
                        checked={psicTestorinRad === "No"}
                        onChange={(e) => setPsicTestorinRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div> */}

                {/* <div className='lock'>
                  <div className='field'>
                    <label htmlFor='psicTipoDroga'>Tipo de droga</label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='psicTipoDroga'
                          name='psicTipoDroga'
                          value={psicTipoDroga}
                          onChange={(e) => setPsicTipoDroga(e.target.value)}
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='cocai'>Cocaína</option>
                          <option value='alcoh'>Alcohol</option>
                          <option value='hach'>Hachís</option>
                          <option value='benzo'>Benzodiacepinas</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='field'>
                    <label htmlFor='psicResult'>Resultado</label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='psicResult'
                          name='psicResult'
                          value={psicResult}
                          onChange={(e) => setPsicResult(e.target.value)}
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='posit'>Positivo</option>
                          <option value='negat'>Negativo</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="field">
                <label className="" htmlFor="psicObs">
                  Observaciones
                </label>
                <div className="control">
                  <textarea
                    className="textarea"
                    name="psicObs"
                    id="psicObs"
                    value={psicObs}
                    onChange={(e) => setPsicObs(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id="actions">
          {(diffDate <= 72 || props.userRole.includes("administrador")) && (
            <button
              className="button is-link"
              id="saveButton"
              form="formUpdatelement"
              type="submit"
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
            </button>
          )}
          <Link
            className="button is-link is-light"
            to={`../${tratamientoId}/seguimiento/psicoterapia/${psicoterapia.id}`}
          >
            Cancelar
          </Link>
          {props.userRole.includes("administrador") && (
            <button
              className="button is-danger"
              id="deleteButton"
              onClick={deleteItem}
              disabled={isDeletingButton}
            >
              {isDeletingButton ? <div className="spinner"></div> : "Eliminar"}
            </button>
          )}
        </div>
      )}
    </>
  );
}
